import { AlertIcon, ShieldIcon, TrashIcon } from './Icons';

// Styled replacement for window.confirm / alert.
// Usage: <ConfirmDialog open={...} title="..." message="..." tone="danger|primary|neutral"
//         confirmLabel="Delete" onConfirm={fn} onClose={fn} error="optional error text" />
// Alert-only mode (no confirm button): pass onConfirm={null}.
export default function ConfirmDialog({ open, title, message, tone = 'primary', confirmLabel = 'Confirm', busy = false, error = '', onConfirm, onClose }) {
  if (!open) return null;

  const tones = {
    danger:  { iconBg: 'bg-red-50',    icon: <TrashIcon size={20} className="text-red-500" />,   btn: 'bg-red-500 hover:bg-red-600' },
    primary: { iconBg: 'bg-[#fde8e3]', icon: <ShieldIcon size={20} className="text-[#e8614a]" />, btn: 'bg-[#fb866d] hover:bg-[#e8614a]' },
    neutral: { iconBg: 'bg-slate-100', icon: <AlertIcon size={20} className="text-slate-500" />,  btn: 'bg-[#0f1b33] hover:bg-[#1a2744]' },
  };
  const t = tones[tone] || tones.primary;

  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center p-4"
      style={{ background: 'rgba(15,27,51,0.5)', backdropFilter: 'blur(4px)' }}
      onClick={e => e.target === e.currentTarget && !busy && onClose()}>
      <div className="bg-white rounded-2xl w-[420px] max-w-full shadow-2xl"
        style={{ animation: 'confirmPop 0.16s ease' }}>
        <style>{`@keyframes confirmPop { from { transform: scale(0.95); opacity: 0; } to { transform: scale(1); opacity: 1; } }`}</style>

        <div className="p-6">
          <div className={`w-12 h-12 rounded-xl flex items-center justify-center mb-4 ${t.iconBg}`}>
            {t.icon}
          </div>
          <h2 className="text-[16px] font-bold text-slate-800 mb-1.5">{title}</h2>
          <p className="text-[13.5px] text-slate-500 leading-relaxed whitespace-pre-line">{message}</p>
          {error && (
            <div className="mt-3 px-4 py-3 rounded-xl text-[13px] bg-red-50 border border-red-200 text-red-600">{error}</div>
          )}
        </div>

        <div className="flex items-center justify-end gap-2.5 px-6 pb-5">
          <button onClick={onClose} disabled={busy}
            className="px-5 py-2.5 border border-slate-200 rounded-full text-sm font-semibold text-slate-600 hover:border-slate-400 transition-all disabled:opacity-50">
            {onConfirm ? 'Cancel' : 'Close'}
          </button>
          {onConfirm && (
            <button onClick={onConfirm} disabled={busy}
              className={`px-6 py-2.5 rounded-full text-white text-sm font-semibold transition-all disabled:opacity-60 ${t.btn}`}>
              {busy ? 'Working...' : confirmLabel}
            </button>
          )}
        </div>
      </div>
    </div>
  );
}